import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { CheckNotes, SummaryNotes } from '@authority-labs/api-interfaces';
import { CheckNotesComponent } from '../check-notes/check-notes.component';

@Component({
  selector: 'authority-labs-check-summary-notes',
  templateUrl: './check-summary-notes.component.html',
  styleUrls: ['./check-summary-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckSummaryNotesComponent
  extends CheckNotesComponent
  implements OnInit {
  @Input() notes: SummaryNotes[] = [];
  @Output() dataChange: EventEmitter<SummaryNotes[]> = new EventEmitter();

  editableSubNoteIndex: number | null = null;
  editableSubNote: CheckNotes;
  addSubNoteToSummeryIndex: number | null = null;
  subNote: string;

  dropSubNotes(note: SummaryNotes, event: CdkDragDrop<string[]>) {
    moveItemInArray(note.subNotes, event.previousIndex, event.currentIndex);
    this.onChange();
  }

  addSubNote(summeryNoteIndex: number): void {
    this.addSubNoteToSummeryIndex = summeryNoteIndex;
    this.subNote = '';
  }

  saveSubNote(note: SummaryNotes): void {
    note.subNotes = note.subNotes || [];
    note.subNotes.push({
      addNotesToReport: true,
      notes: this.subNote
    });
    this.addSubNoteToSummeryIndex = null;
    this.onChange();
  }

  removeSubNote(note: SummaryNotes, subnoteIndex: number): void {
    note.subNotes.splice(subnoteIndex, 1);
    this.onChange();
  }

  editSubNote(subNote: CheckNotes): void {
    this.editableSubNote = subNote;
  }

  applySubnoteChanges(): void {
    this.editableSubNote = null;
    this.onChange();
  }
}
